import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import axios from 'helpers/api';
import paths from 'routes/paths';
import { normalizeAtHomePatients } from './MyPatientsList';

const StatCard = ({ icon, label, value, to, color = 'primary' }) => (
  <Col xs={12} md={6} xxl={3}>
    <Card className="h-100">
      <Card.Body>
        <Row className="align-items-center g-0">
          <Col xs="auto">
            <span className={`f-icon-wrapper text-${color}`}>
              <FontAwesomeIcon icon={icon} className={`fs-2 text-${color}`} />
            </span>
          </Col>
          <Col className="ps-3">
            <h6 className="mb-1 text-600">{label}</h6>
            <div className="fs-3 fw-semibold">{value}</div>
          </Col>
        </Row>
        {to && (
          <Link to={to} className="stretched-link" aria-label={label} />
        )}
      </Card.Body>
    </Card>
  </Col>
);

/**
 * UI-039: SharedLiving caregiver dashboard tiles. Scoped to the caregiver's
 * assigned patients only. Keeps the data light (patient count + quick links to
 * MedPass / Reports) since facility-wide aggregation APIs are not in scope.
 */
const CaregiverDashboard = () => {
  const [patientCount, setPatientCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const tokenStr = localStorage.getItem('accessToken');
        const { data } = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/athome/my-patients`,
          { headers: { Authorization: `Bearer ${tokenStr}` } }
        );
        setPatientCount(normalizeAtHomePatients(data).length);
      } catch (error) {
        setPatientCount(0);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <>
      <div className="mb-3">
        <h5 className="mb-1">Welcome back</h5>
        <p className="text-600 mb-0">Here are the patients in your care.</p>
      </div>
      <Row className="g-3 mb-3">
        <StatCard
          icon="hospital-user"
          label="My Patients"
          value={loading ? <Spinner animation="border" size="sm" /> : patientCount}
          to={paths.caregiverMyPatients}
          color="primary"
        />
        <StatCard
          icon="mobile"
          label="MedPass"
          value={<FontAwesomeIcon icon="arrow-right" className="fs-5" />}
          to={paths.medpassdashboard}
          color="success"
        />
      </Row>
    </>
  );
};

export default CaregiverDashboard;
